import * as React from "react";
import { BaseModal } from "../../atoms/base-modal";
import classNames from "classnames";

export const ConfirmModal: React.FC<{
  isActive: boolean;
  title: string;
  banner?: JSX.Element;
  body: string;
  bodySecondRow?: string;
  successButtonText: string;
  isSuccessLoading?: boolean;
  onSuccess: () => void;
  onClose: () => void;
}> = ({
  isActive,
  title,
  banner,
  body,
  bodySecondRow,
  successButtonText,
  isSuccessLoading,
  onSuccess,
  onClose,
}) => {
  return (
    <BaseModal isActive={isActive} title={title} onClose={onClose}>
      <section className="modal-card-body">
        {!!banner && <div className="field">{banner}</div>}
        <div className="is-small">{body}</div>
        {!!bodySecondRow && <div className="is-small">{bodySecondRow}</div>}
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onClose}>
          キャンセル
        </button>
        <button
          className={classNames("button is-info is-fullwidth", {
            "is-loading": isSuccessLoading,
          })}
          onClick={onSuccess}
        >
          {successButtonText}
        </button>
      </footer>
    </BaseModal>
  );
};
